require('./notify-tab.component.scss');

class NotifyTabController {
  constructor(
    $scope,
    $http,
    PermissionService,
    FilterResource,
  ) {
    this.FilterResource = FilterResource;
    this.$scope = $scope;
    if (!this.$scope.filter.notifyShMonthDay) this.$scope.filter.notifyShMonthDay = 1;
    if (this.$scope.filter.sendMail === undefined) this.$scope.filter.sendMail = true;
    if (this.$scope.filter.use_default_email === undefined) {
      this.$scope.filter.use_default_email = true;
    }
    const schedule = this.$scope.filter.notify ?
      this.$scope.filter.reporting_schedule_type :
      false;
    this.$scope.notify2.schedule = this.$scope.filter.reporting_schedule_type ? this.$scope.filter.reporting_schedule_type : 'new';
    this.$scope.notify2.adminMailShow = `${PermissionService.userName}(${PermissionService.userMail})`;
    this.$scope.notify2.adminMail = PermissionService.userMail ?
      `${PermissionService.userName}<${PermissionService.userMail}>` :
      '';
    this.$scope.notify2.active = this.$scope.filter.notify ||
      this.$scope.filter.send_threshold;

    const getShTime = () =>
      this.$scope.filter.notifyShTime ?
      `${Math.floor(this.$scope.filter.notifyShTime / 3600)
            .toString()
            .padStart(2, '0')}:${Math.floor(
            (this.$scope.filter.notifyShTime % 3600) / 60
          )
            .toString()
            .padStart(2, '0')}` :
      '06:00';

    if (this.$scope.show.threshold()) {
      this.$scope.filter.notify = false;
      this.$scope.filter.notifyIsHtml = false;
    }


    this.$scope.notify2.shTime = getShTime();

    this.$scope.notify2.changeActive = v => {
      this.$scope.filter.notify = v;
      if (!v && !this.$scope.filter.reporting_schedule_type) {
        this.$scope.notify2.schedule = 'new';
        this.$scope.filter.reporting_schedule_type = '';
      }
    };

    if (this.$scope.filter.notifyIsRendered) {
      this.$scope.notify2.reportType = 'notifyIsRendered';
    } else if (this.$scope.filter.notifyIsPdf) {
      this.$scope.notify2.reportType = 'notifyIsPdf';
    } else if (this.$scope.filter.notifyIsXls) {
      this.$scope.notify2.reportType = 'notifyIsXls';
    } else {
      this.$scope.notify2.reportType = this.$scope.show.threshold() ? 'notifyIsPdf' : 'notifyIsHtml';
    }

    this.$scope.isNoRenderModes = () => {
      if (this.$scope.filter.send_threshold) return false;
      const noRender = this.$scope.filter.isGraph ||
        this.$scope.filter.isEventRiver ||
        this.$scope.filter.isRadar ||
        this.$scope.filter.isChart ||
        this.$scope.filter.isTree ||
        this.$scope.filter.isChartArea ||
        this.$scope.filter.isHeatmap;
      if (this.$scope.notify2.reportType === 'notifyIsRendered' && noRender) {
        this.$scope.notify2.reportType = 'notifyIsPdf';
        this.$scope.filter.notifyIsPdf = true;
        this.$scope.filter.notifyIsRendered = false;
      }
      return noRender;
    };
    this.$scope.isNoRenderModes();

    this.$scope.notify2.shTimeBlur = () => {
      const [h, m] = this.$scope.notify2.shTime
        .split(':')
        .map(t => parseInt(t, 0));

      if (
        typeof h === 'number' &&
        typeof m === 'number' &&
        ((h < 24 && m < 60) || (h === 24 && m === 0))
      ) {
        this.$scope.notify2.shTime = `${h
          .toString()
          .padStart(2, '0')}:${m.toString().padStart(2, '0')}`;
      } else {
        console.error('bad shTime', this.$scope.notify2.shTime);
        this.$scope.notify2.shTime = getShTime();
      }
      this.$scope.filter.notifyShTime = getNotifyShTime();
    };

    const getNotifyShTime = () => {
      const [h, m] = this.$scope.notify2.shTime
        .split(':')
        .map(t => parseInt(t, 0));
      return h * 3600 + m * 60;
    };

    this.$scope.notify2.reportTypeChange = v => {
      this.$scope.filter.setNotifyType(this.$scope.notify2);
    };

    this.$scope.notify2.scheduleChange = v => {
      if (!v) return;
      this.$scope.filter.reporting_schedule_type = v === 'new' ? '' : v;
      if (v !== 'new') {
        if (this.$scope.notify2.reportType === 'notifyIsHtml') {
          this.$scope.notify2.reportType = 'notifyIsRendered';
        }
      }
      this.$scope.filter.setNotifyType(this.$scope.notify2);
    };

    this.$scope.notify2.isShowSchedule = () =>
      this.isActive && this.$scope.notify2.notifyType !== 'HTML';

    this.$scope.notify2.isRenderDisable = () => !this.isActive ||
      this.$scope.isNoRenderModes();

    this.$scope.notify2.isHtmlDisable = () => {
      const res = !this.isActive || this.$scope.notify2.schedule !== 'new' ||
        (this.$scope.filter.isReports &&
          (this.$scope.filter.url !== '/analytics/report/facts/' &&
            this.$scope.filter.url !== '/analytics/report/sites/'));
      if (res && this.$scope.filter.notifyIsHtml) {
        this.$scope.filter.notifyIsRendered = true;
        this.$scope.filter.notifyIsHtml = false;
        this.$scope.notify2.reportType = 'notifyIsRendered';
      }
      return res;
    };

    this.$scope.setAdminEmail = () => {
      this.$scope.filter.emails = this.$scope.notify2.adminMail;
    };

    this.$scope.notify2.isSendToMe = () =>
      this.$scope.notify2.adminMail && !this.$scope.filter.emails;

    this.$scope.notify2.setSplitByUsers = () => {
      if (!this.$scope.filter.split_by_user) return;
      if (this.$scope.filter.notifyIsHtml)
        this.$scope.filter.split_by_user = false;
    };

    this.$scope.notify2.isPdfDisable = () =>
      !this.isActive || this.$scope.notify2.schedule !== 'new';

    this.$scope.notify2.splitByUsersDisable = () =>
      !this.isActive ||
      this.$scope.filter.do_scan ||
      this.$scope.filter.notifyIsHtml ||
      this.$scope.filter.notifyIsRendered;

    this.$scope.responsePatterns = [];
    this.$scope.incidentGroups = [];

    const initcreateIncident = () => {
      if (
        this.$scope.incidentGroups &&
        this.$scope.incidentGroups[0] &&
        !this.$scope.filter.createIncidentGroup
      )
        this.$scope.filter.createIncidentGroup = this.$scope.incidentGroups[0].id.toString();
      if (
        this.$scope.responsePatterns &&
        this.$scope.responsePatterns[0] &&
        !this.$scope.filter.createIncidentPattern
      )
        this.$scope.filter.createIncidentPattern = this.$scope.responsePatterns[0].id.toString();
    };

    this.$scope.onSendMail = () => {
      if (this.$scope.notify2.schedule !== 'new') {
        this.$scope.filter.createIncident = false;
        this.$scope.filter.sendMail = true;
      } else if (!this.$scope.filter.sendMail)
        this.$scope.filter.createIncident = true;
      this.$scope.onCreateIncident();
    };

    this.$scope.disableIncident = () => {
      return !this.$scope.filter.send_threshold &&
        (!this.isActive || this.$scope.notify2.schedule !== 'new' || this.$scope.filter.notifyIsPdf);
    };

    this.$scope.onCreateIncident = () => {
      if (!this.$scope.filter.createIncident) {
        delete this.$scope.filter.createIncidentPattern;
        delete this.$scope.filter.createIncidentGroup;
        this.$scope.filter.sendMail = true;
      }
      if (
        !this.$scope.responsePatterns.length ||
        !this.$scope.incidentGroups.length
      ) {
        Promise.all([
          $http.get('/incident/api/response_pattern/'),
          $http.get('/incident/api/incident_group/')
        ]).then(
          res => {
            if (res[0] && res[0].data) {
              this.$scope.responsePatterns = res[0].data;
            }
            if (res[1] && res[1].data) {
              this.$scope.incidentGroups = res[1].data;
            }
            initcreateIncident();
            this.$scope.$root.$apply();
          },
          err => {
            console.error(err);
          }
        );
      } else initcreateIncident();
    };
    if (this.$scope.filter.createIncident) this.$scope.onCreateIncident();
  }

  get isActive() {
    return this.$scope.filter.isPolitic ?
      this.$scope.filter.do_scan && this.$scope.notify2.active : this.$scope.notify2.active;
  }

  $onInit() {
    this.$scope.notify2.scheduleChange(this.$scope.notify2.schedule);
    this.$scope.notify2.setSplitByUsers();
  }

  get showCreateIncident() {
    return !this.$scope.filter.isCardOrDashboard &&
      this.$scope.filter.content_type !== 'generalreportfilter';
  }

  get hideNewEvents() {
    return this.$scope.filter.isCardOrDashboard || this.$scope.filter.content_type === 'generalreportfilter';
  }
}

export function NotifyTabComponent() {
  return {
    restrict: 'E',
    template: require('./notify-tab.component.html'),
    scope: false,
    controller: NotifyTabController,
    controllerAs: '$ctrl',
  };
}



// WEBPACK FOOTER //
// ./src/filter/editor/tabs/notify-tab.component.js